/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionInformationsQuery from '../graphql/queries/GetSouscriptionInformationsQuery.js';

const useGetSouscriptionInformationsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionInformationsQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionInformations: R.omit(['__typename'], data?.getSouscriptionInformations_souscription_informations || {})
  };
};

export default useGetSouscriptionInformationsQuery;
